var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm._v($t("k8cc828", "绿云企业服务协议"))]);
};
var staticRenderFns = [];
export { render, staticRenderFns };